import styled from "styled-components";

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  text-align: left;
`;

export const SearchUsersWrapper = styled.div`
  width: 100%;

  &  > div, &  > div > div {
    width: 100% !important;
  }
`;

export const ToBeAddedWrapper = styled.div`
  width: 100%;
  display: ${props => props.$hasUsers ? 'flex' : 'none'};
  flex-direction: column;
  gap: 8px;
`;

export const TotallyToAddWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ToBeAddedList = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 145px;
  overflow-y: auto;

  /* Chrome/Edge/Safari */
  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-track {
    background: ${props => props.theme.colors.highClearGray};
  }
  &::-webkit-scrollbar-thumb {
    background: ${props => props.theme.colors.lighterGray};
    border-radius: 3px;
  }

  /* Firefox */
  scrollbar-width: thin;
  scrollbar-color: 
    ${props => props.theme.colors.lighterGray}
    ${props => props.theme.colors.highClearGray};
`;

export const ToBeAddedItem = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  height: 40px;
`;

export const ToBeAddedItemLeft = styled.div`
  display: flex;
  flex-direction: row;
  gap: 9px;
  justify-content: flex-start;
  align-items: center;
  
`;

export const ToBeAddedItemRight = styled.div`
  display: flex;
  flex-direction: row;
  gap: 9px;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
`;

export const ActionsWrapper = styled.div`
  display: ${props => props.$hasUsers ? 'block' : 'none'};
`;

